/**
 * Minimum gap between two read starts. The upstream Liv allows about ten
 * requests per ten seconds; a 60-turn run read faster than this is answered
 * with 429 (503 here) for the rest of the burst.
 */
export const TEXT_READ_GAP_MS = 1100;
